"use client";

import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { Card } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { CirclePlay } from "lucide-react";
function VideoConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid gap-6 md:grid-cols-2">
        <div className="h-96 rounded-lg bg-muted/30 animate-pulse" />
        <div className="space-y-4">
          <div className="h-8 w-3/4 rounded bg-muted/30 animate-pulse" />
          <div className="h-4 w-full rounded bg-muted/30 animate-pulse" />
          <div className="h-4 w-5/6 rounded bg-muted/30 animate-pulse" />
        </div>
      </div>;
  }
  if (error) {
    return <div className="text-center text-black">
        Failed to load video content.
      </div>;
  }
  const featuredVideo = posts[0];
  if (!featuredVideo) {
    return null;
  }
  return <div className="grid gap-8 md:grid-cols-2 md:gap-12 items-center">
      
      <div className="order-2 md:order-1">
        <Card className="overflow-hidden border-border group transition-transform duration-[var(--duration-medium)] hover:scale-[1.01]">
          <AspectRatio ratio={16 / 9}>
            {featuredVideo.customFields?.thumbnail ? <div className="relative w-full h-full">
                <img src={featuredVideo.customFields.thumbnail} alt={featuredVideo.customFields?.title || featuredVideo.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors duration-[var(--duration-medium)]">
                  <CirclePlay className="w-16 h-16 text-white opacity-90" />
                </div>
              </div> : featuredVideo.featuredImage ? <div className="relative w-full h-full">
                <img src={featuredVideo.featuredImage} alt={featuredVideo.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/50 transition-colors duration-[var(--duration-medium)]">
                  <CirclePlay className="w-16 h-16 text-white opacity-90" />
                </div>
              </div> : <div className="w-full h-full bg-muted flex items-center justify-center">
                <CirclePlay className="w-16 h-16 text-black" />
              </div>}
          </AspectRatio>
        </Card>
      </div>

      
      <div className="order-1 md:order-2 space-y-6">
        <div>
          <h2 className="text-4xl md:text-5xl font-display font-bold mb-4 text-foreground">
            {featuredVideo.customFields?.title || featuredVideo.title}
          </h2>
          {featuredVideo.customFields?.description && <p className="text-lg text-black leading-relaxed">
              {featuredVideo.customFields.description}
            </p>}
          {!featuredVideo.customFields?.description && featuredVideo.excerpt && <div className="text-lg text-black leading-relaxed" dangerouslySetInnerHTML={{
          __html: featuredVideo.excerpt
        }} />}
        </div>

        {featuredVideo.customFields?.url && <Link to={featuredVideo.customFields.url} newTab className="inline-flex items-center gap-2 px-6 py-3 bg-accent text-black rounded-md font-medium hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 active:bg-accent-active active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
            <CirclePlay className="w-5 h-5" />
            Watch Video
          </Link>}
      </div>
    </div>;
}
export default function TheScienceOfProtection() {
  return <section id="the-science-of-protection" className="py-16 px-6 bg-cover bg-center bg-no-repeat !bg-[url(https://newmavericks.com/wp-content/uploads/2026/02/image_m4f5bnnb.png)] flex items-center !h-[1600px] md:py-24">
      <div className="max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-stretch">
          
          <div className="flex flex-col items-center justify-center gap-0">
            <img src="https://newmavericks.com/wp-content/uploads/2026/03/Ebook-Front-Cover_The-Science-of-Protection_Web_Preview-copy.png" alt="Scientific Analysis of Protection Systems" className="w-[500px] h-[800px] object-cover shadow-strong" />
            <img src="https://newmavericks.com/wp-content/uploads/2026/03/Ebook-Back-Cover_The-Science-of-Protection_Web_Preview-copy.png" alt="Technical Security Implementation Detail" className="w-[500px] h-[800px] object-cover shadow-strong" />
          </div>

          <div className="flex flex-col">
            <h2 className="font-display font-bold text-foreground ![margin:80px_0px_0px_-20px] !text-3xl !text-center">Our SCIENCE OF PROTECTION activates peak state leadership consciousness &amp; <br />six core protection pillars that protect &amp; enhance your SCIENCE OF ACHIEVEMENT</h2>
            <p className="leading-relaxed text-center !text-[hsl(0,0%,100%)] ![margin:50px_0px_0px_0px] !text-xl md:text-left">1. Purification - of stress, negativity, vices, fears & doubts have even more CLARITY to simplify the complex.</p>
            <p className="leading-relaxed text-center !text-[hsl(0,0%,100%)] ![margin:50px_0px_0px_0px] !text-xl md:text-left">2. Coherence - to unify differences with COHERENCE within & between people so everyone is on the same page.</p>
            <p className="leading-relaxed text-center !text-[hsl(0,0%,100%)] ![margin:50px_0px_0px_0px] !text-xl md:text-left">3. Leadership State - an awake truthful CREATIVE mind to avert dangers & see opportunities before they arise.</p>
            <p className="leading-relaxed text-center !text-[hsl(0,0%,100%)] ![margin:50px_0px_0px_0px] !text-xl md:text-left">4. Capacity - CAPACITY mind to avert dangers & see opportunities before they arise.</p>
            <p className="leading-relaxed text-center !text-[hsl(0,0%,100%)] ![margin:50px_0px_0px_0px] !text-xl md:text-left">5. Spontaneous Right Action - to make timely CATALYST decisions that inspire new growth.</p>
            <p className="leading-relaxed text-center !text-[hsl(0,0%,100%)] ![margin:50px_0px_0px_0px] !text-xl md:text-left">6. Deserving Power - to CAPITALIZE on opportunities by having maximum support from people.</p>
            <p className="leading-relaxed !text-[hsl(0,0%,100%)] !text-center ![margin:50px_0px_0px_0px] !text-xl"><b className="!text-2xl">These six protection pillars are accomplished using proven time &amp; field-tested leadership knowledge, techniques, technologies, and approaches.</b></p>
          </div>
        </div>
      </div>
    </section>;
}